import { LoadableRoute } from 'routes/utils/loadable';

export const ShortUUIDConverterContainer = LoadableRoute({
  loader: () =>
    import(/* webpackChunkName: "ShortUUIDConverter" */ './ShortUUIDConverter'),
});
